import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  Schedule as ScheduleIcon
} from '@mui/icons-material';
import './ContactInfo.css';

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: <EmailIcon />,
      primary: 'Email',
      secondary: 'contact@missionsport.fr',
      link: 'mailto:contact@missionsport.fr'
    },
    {
      icon: <PhoneIcon />,
      primary: 'Téléphone',
      secondary: '+33 1 23 45 67 89',
      link: 'tel:+33123456789'
    },
    {
      icon: <LocationIcon />,
      primary: 'Adresse',
      secondary: '123 Avenue du Sport, 75001 Paris, France',
      link: 'https://maps.google.com/?q=123+Avenue+du+Sport,+75001+Paris,+France'
    },
    {
      icon: <ScheduleIcon />,
      primary: 'Horaires',
      secondary: 'Lun-Ven: 9h-18h | Sam: 9h-12h',
      link: null
    }
  ];

  return (
    <Box className="contact-info">
      <Typography variant="h4" component="h2" className="info-title" gutterBottom>
        Nos coordonnées
      </Typography>
      
      <Typography variant="body1" className="info-subtitle" sx={{ mb: 3 }}>
        Plusieurs moyens de nous contacter selon vos préférences.
      </Typography>

      <List className="contact-list">
        {contactDetails.map((detail, index) => (
          <ListItem 
            key={index} 
            className="contact-item"
            component={detail.link ? 'a' : 'div'}
            href={detail.link || undefined}
            target={detail.link && detail.link.startsWith('http') ? '_blank' : undefined}
            rel={detail.link && detail.link.startsWith('http') ? 'noopener noreferrer' : undefined}
          >
            <Card className="contact-card" elevation={0}>
              <CardContent className="contact-card-content">
                <ListItemIcon className="contact-icon">
                  {detail.icon}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h6" className="contact-primary">
                      {detail.primary}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" className="contact-secondary">
                      {detail.secondary}
                    </Typography>
                  }
                />
              </CardContent>
            </Card>
          </ListItem>
        ))}
      </List>

      <Card className="response-time-card">
        <CardContent>
          <Typography variant="h6" className="response-title" gutterBottom>
            Temps de réponse
          </Typography>
          <Typography variant="body2" className="response-text">
            📧 Email : Sous 24h en moyenne
          </Typography>
          <Typography variant="body2" className="response-text">
            📞 Téléphone : Réponse immédiate aux heures d'ouverture
          </Typography>
          <Typography variant="body2" className="response-text">
            🚀 Urgences : Contactez-nous par téléphone
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ContactInfo;